/**
* Endpoint methods related to the Webshop
*/
import API from "./Api";


export default {
  /**
  * Updates the Webshop Settings
  */
  async update(body) {
    return API.post("/webshop/update", body, "MOODLE_SESSION_JSON");
  },
  /**
   * [PUBLIC ENDPOINT]
  * Gets all the items in the Webshop
  */
  async readallown(body) {
    return API.post("/webshop/readallown", body, "PLAIN_JSON");
  },

  async readall(body) {
    return API.post("/webshop/readall", body, "PLAIN_JSON");
  },

  /**
   * [PUBLIC ENDPOINT]
  * Gets the course data specfic to the Webshop
  */
  async getCourse(body) {
    return API.get("/webshop/" + body.webshop_id + "/courses/" + body.course_id, "PLAIN_JSON");
  }

}